import React, { createContext, useContext } from 'react';
import posed from 'react-pose';
import './navigation.css'
import Nav from "./Nav";
import menu from "./../../../media/icons/menu.svg"

const MenuDiv = posed.div({
  open: { width: '350px', staggerChildren: 75, delayChildren: 200 },
  closed: { width: 0, delay: 400, staggerChildren: 30 }
});

const MenuMobileDiv = posed.div({
  open: { width: '100vw', staggerChildren: 75, delayChildren: 200 },
  closed: { width: 0, delay: 400, staggerChildren: 30 }
});

const ClickDiv = posed.div({
  open: { left: '350px' },
  closed: { left: 0, delay: 400 }
});
const ClickMobileDiv = posed.div({
  open: { left: '100vw', opacity: 0 },
  closed: { left: 0, opacity: 1, delay: 400 }
});

const NavigationContext = createContext({
  isMenuOpen: false,
  setMenuOpen: () => null,
  isMenuVisible: false,
  setMenuVisible: () => null

})
const useNavigationContext = () => useContext(NavigationContext)

const Navigation = ({ children }) => {
  const [isMenuOpen, setMenuOpen] = React.useState(false);
  const [isMenuVisible, setMenuVisible] = React.useState(true);

  const closeMenu = () => setMenuOpen(false);
  const toggleMenu = () => setMenuOpen(!isMenuOpen);

  return (
    <NavigationContext.Provider value={{ isMenuOpen, setMenuOpen, isMenuVisible, setMenuVisible }}>
      <div className="container-fluid">
        <div className="row flex-nowrap min-vh-100">
          {isMenuVisible && (
            <React.Fragment>
              <MenuDiv
                className="d-none d-md-block col-auto px-0 bg-primary vh-100 position-sticky overflow-hidden bg-nav"
                style={{ top: 0, zIndex: 100 }}
                pose={isMenuOpen ? "open" : "closed"}>
                <Nav closeMenu={closeMenu}/>
              </MenuDiv>
              <MenuMobileDiv
                className="d-md-none col-auto px-0 bg-primary vh-100 position-fixed overflow-hidden bg-nav"
                style={{ top: 0, zIndex: 100 }}
                pose={isMenuOpen ? "open" : "closed"}>
                <Nav closeMenu={closeMenu}/>
              </MenuMobileDiv>
              <ClickDiv onClick={toggleMenu} style={{ top: 20, zIndex: 110, cursor: "pointer" }}
                        className="d-none d-md-block position-fixed p-2 bg-nav" pose={isMenuOpen ? "open" : "closed"}>
                <img width="25px" height="25px" src={menu} alt=""/>
              </ClickDiv>
              <ClickMobileDiv onClick={toggleMenu}
                              style={{ top: 20, zIndex: 110, cursor: "pointer" }}
                              className="d-md-none position-fixed p-2 bg-nav" pose={isMenuOpen ? "open" : "closed"}>
                <img width="25px" height="25px" src={menu} alt=""/>
              </ClickMobileDiv>
            </React.Fragment>
          )}

          <div className="col">
            {children}
          </div>
        </div>
      </div>
    </NavigationContext.Provider>
  );
}

export default Navigation;
export { useNavigationContext }
